<template>
  <svg width="28" height="21" viewBox="0 0 28 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="28" height="3" rx="1.5" fill="currentColor" />
    <rect y="9" width="28" height="3" rx="1.5" fill="currentColor" />
    <rect y="18" width="28" height="3" rx="1.5" fill="currentColor" />
  </svg>
</template>
